import React, { useEffect, useRef, useState } from 'react';
import { useEquipmentPage } from '../context/EquipmentPageContext';
import { localDate, retired } from '../equipmentData';

export default function EquipmentMaintenanceCalendar() {
  const { calendarOpen, setCalendarOpen, records, setSelectedEquipment } = useEquipmentPage();
  const [month, setMonth] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const dialog = useRef(null);
  useEffect(() => {
    if (calendarOpen) dialog.current?.showModal();
    else dialog.current?.close();
  }, [calendarOpen]);
  const days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const offset = (month.getDay() + 6) % 7;
  const schedule = records.filter(item => !retired(item) && item.requiresRoutineMaintenance && item.nextMaintenanceDate);
  return <dialog ref={dialog} onCancel={() => setCalendarOpen(false)} onClick={event => { if (event.target === dialog.current) setCalendarOpen(false); }}
    aria-label="Maintenance calendar" className="w-full max-w-3xl rounded-2xl border border-slate-200 p-6 text-slate-800 shadow-xl backdrop:bg-slate-900/30">
    <div className="flex items-center justify-between gap-3 mb-4">
      <h2 className="text-lg font-bold">Maintenance Calendar</h2>
      <button type="button" onClick={() => setCalendarOpen(false)} className="rounded-lg border border-slate-200 px-3 py-1 text-sm">Close</button>
    </div>
    <div className="flex items-center justify-between mb-4 text-sm">
      <button type="button" aria-label="Previous month" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} className="rounded-lg border border-slate-200 px-3 py-1">‹</button>
      <span className="font-semibold">{month.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}</span>
      <button type="button" aria-label="Next month" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} className="rounded-lg border border-slate-200 px-3 py-1">›</button>
    </div>
    <div className="grid grid-cols-7 gap-1 text-xs">
      {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => <div key={day} className="py-2 text-center font-semibold text-slate-400">{day}</div>)}
      {Array.from({ length: offset }, (_, index) => <div key={'empty-' + index} />)}
      {Array.from({ length: days }, (_, index) => {
        const day = index + 1, date = localDate(new Date(month.getFullYear(), month.getMonth(), day));
        const items = schedule.filter(item => item.nextMaintenanceDate.slice(0, 10) === date);
        return <div key={date} className="min-h-20 rounded-lg border border-slate-100 p-2">
          <span className="text-slate-500">{day}</span>
          {items.map(item => <button key={item.id} type="button" onClick={() => { setCalendarOpen(false); setSelectedEquipment(item); }} className="mt-1 block w-full truncate rounded bg-blue-50 px-1 py-1 text-left text-[10px] font-semibold text-blue-600" title={item.name}>{item.name}</button>)}
        </div>;
      })}
    </div>
    <p className="mt-4 text-xs text-slate-400">Scheduled dates for the equipment in the selected registration range and filters.</p>
  </dialog>;
}
